// extracted by mini-css-extract-plugin
export default {"cardscontainer":"FAQtheme_cardscontainer__8-+LW","FAQthemecard":"FAQtheme_FAQthemecard__XEyzZ","mainContainer":"FAQtheme_mainContainer__Advm3"};